import React from 'react';
import PropTypes from 'prop-types';
import InputElementWithLabel from './InputElementWithLabel.jsx';
import MessageView from '../../../../../Common/Components/MessageView.jsx';
import { caseInsensitiveComparison } from '../../../../../Common/Utilities/StringUtilities';
import { sortMapByProperty } from '../../../../../Common/Utilities/MapUtilities';

class RadioboxRatesFilter extends React.PureComponent {
    constructor() {
        super();
        this.state = {
            showInformationMessage: false
        }
    }

    render () {
        const sortedValues = sortMapByProperty(this.props.options, 'name', caseInsensitiveComparison);
        const isItemSelected = (name) => !!this.props.selectedOptions.find(obj => obj.get('name') === name);
        const filterOptions = sortedValues.map(filterOption =>
            <li key={ filterOption.get('id') } className="radiobox">
                <div className="ui radio checkbox">
                    <InputElementWithLabel
                        autoFocus={ Object.is(filterOption, sortedValues.first()) }
                        label={ filterOption.get('name') }
                        value={ filterOption.get('id') }
                        isChecked={ isItemSelected(filterOption.get('name')) }
                        inputElementName="radio"
                        onChange={ this.onChange } />
                </div>
            </li>);

        return (
            <div>
                <ul className="ratesFilter list">{filterOptions}</ul>
                {
                    this.state.showInformationMessage && this.props.changeMessage
                        ? this.renderInformationMessage()
                        : null
                }
            </div>
        )
    }

    renderInformationMessage = () =>
        <MessageView
            severity="information"
            icon="check"
            messages={ [this.props.changeMessage] }
            closeable={ true }
            onClose={ this.onCloseInformationMessage }/>

    onCloseInformationMessage = (event) =>
        this.setState({ showInformationMessage: false });

    onChange = (value, isSelected) => {
        this.setState({ showInformationMessage: true });
        this.props.onChange(this.props.category, [value]);
    }

    static propTypes = {
        category: PropTypes.string.isRequired,
        options: PropTypes.object.isRequired,
        selectedOptions: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired,
        changeMessage: PropTypes.string
    }
}

export default RadioboxRatesFilter;
